import type { AdminRole } from '@/lib/api-admin/types';

export const VENDOR_ROUTE_ROLES: ReadonlyArray<AdminRole> = [
  'SUPER_ADMIN',
  'OPS_ADMIN',
  'MD_MANAGER',
  'AUDITOR',
];

export type VendorWriteAction =
  | 'assign'
  | 'start-review'
  | 'approve'
  | 'reject'
  | 'request-resubmission'
  | 'issue-credentials';

export const VENDOR_WRITE_ROLES: ReadonlyArray<AdminRole> = ['SUPER_ADMIN', 'MD_MANAGER'];

export const canPerformVendorWrite = (roles: ReadonlyArray<AdminRole>): boolean =>
  VENDOR_WRITE_ROLES.some((r) => roles.includes(r));

export const VENDOR_ACTION_ROLES: Record<VendorWriteAction, ReadonlyArray<AdminRole>> = {
  assign: VENDOR_WRITE_ROLES,
  'start-review': VENDOR_WRITE_ROLES,
  approve: VENDOR_WRITE_ROLES,
  reject: VENDOR_WRITE_ROLES,
  'request-resubmission': VENDOR_WRITE_ROLES,
  'issue-credentials': VENDOR_WRITE_ROLES,
};
